<template>
    <div class="home-page">
        <!-- 顶部统计卡片区域 -->
        <div class="stats-area">
            <!-- 总计卡片 - 带分类标签切换 -->
            <el-card class="stat-card stat-card--main">
                <div slot="header" class="card-tabs">
                    <template v-for="(item, index) in assertsData.assetsStatusClassList">
                        <el-button type="text" :style="{ color: aacType == index ? '#409EFF' : '#606266' }"
                            @click="aacType = index">{{ item.aacName }}</el-button>
                    </template>
                </div>
                <el-descriptions :column="10" border direction="vertical" :labelStyle="{
                    color: '#409EFF',
                    textAlign: 'center',
                    fontSize: '12px'
                }" :contentStyle="{ textAlign: 'center', fontSize: '12px' }"
                    v-if="assertsData.assetsStatusClassList">
                    <el-descriptions-item label="自购">
                        <el-button type="text" style="color:black"
                            @click="toPath(5, 0, assertsData.assetsStatusClassList[aacType].aacId,'自购')">
                            {{ assertsData.assetsStatusClassList[aacType].numsEight }}</el-button>
                    </el-descriptions-item>
                    <el-descriptions-item label="租用">
                        <el-button type="text" style="color:black"
                            @click="toPath(5, 0, assertsData.assetsStatusClassList[aacType].aacId,'租用')">
                            {{ assertsData.assetsStatusClassList[aacType].numsNine }}</el-button>
                    </el-descriptions-item>
                    <el-descriptions-item label="闲置">
                        <el-button type="text" style="color:black"
                            @click="toPath(1, 1, assertsData.assetsStatusClassList[aacType].aacId)">
                            {{ assertsData.assetsStatusClassList[aacType].numsOne }}</el-button>
                    </el-descriptions-item>
                    <el-descriptions-item label="报废">
                        <el-button type="text" style="color:black"
                            @click="toPath(1, 2, assertsData.assetsStatusClassList[aacType].aacId)">
                            {{ assertsData.assetsStatusClassList[aacType].numsTwo }}</el-button>
                    </el-descriptions-item>
                    <el-descriptions-item label="维修">
                        <el-button type="text" style="color:black"
                            @click="toPath(1, 3, assertsData.assetsStatusClassList[aacType].aacId)">
                            {{ assertsData.assetsStatusClassList[aacType].numsThree }}</el-button>
                    </el-descriptions-item>
                    <el-descriptions-item label="领用">
                        <el-button type="text" style="color:black"
                            @click="toPath(1, 4, assertsData.assetsStatusClassList[aacType].aacId)">
                            {{ assertsData.assetsStatusClassList[aacType].numsFour }}</el-button>
                    </el-descriptions-item>
                    <el-descriptions-item label="借用">
                        <el-button type="text" style="color:black"
                            @click="toPath(1, 5, assertsData.assetsStatusClassList[aacType].aacId)">
                            {{ assertsData.assetsStatusClassList[aacType].numsFive }}</el-button>
                    </el-descriptions-item>
                    <el-descriptions-item label="退租">
                        <el-button type="text" style="color:black"
                            @click="toPath(1, 6, assertsData.assetsStatusClassList[aacType].aacId)">
                            {{ assertsData.assetsStatusClassList[aacType].numsSix }}</el-button>
                    </el-descriptions-item>
                    <el-descriptions-item label="丢失">
                        <el-button type="text" style="color:black"
                            @click="toPath(1, 7, assertsData.assetsStatusClassList[aacType].aacId)">
                            {{ assertsData.assetsStatusClassList[aacType].numsSeven }}</el-button>
                    </el-descriptions-item>
                    <el-descriptions-item label="总计">
                        <el-button type="text" style="color:black"
                            @click="toPath(1, 0, assertsData.assetsStatusClassList[aacType].aacId)">
                            {{ assertsData.assetsStatusClassList[aacType].numsTotal }}</el-button>
                    </el-descriptions-item>
                </el-descriptions>
            </el-card>

            <!-- 配件卡片 -->
            <el-card class="stat-card">
                <div slot="header" class="card-title">
                    <span class="title-text">配件</span>
                </div>
                <el-descriptions :column="5" border direction="vertical" :labelStyle="{
                    color: '#409EFF',
                    textAlign: 'center',
                    fontSize: '12px'
                }" :contentStyle="{ textAlign: 'center', fontSize: '12px' }">
                    <el-descriptions-item v-for=" (item, index) in assertsData.fittingStatuses"
                        :label="item.afStatus == 1 ? '闲置' :
                            item.afStatus == 2 ? '报废' : item.afStatus == 3 ? '维修' : item.afStatus == 4 ? '领用' : item.afStatus == 5 ? '借用' : '总数'" :key="index">
                        <el-button type="text" style="color:black" @click="toPath(2)"> {{ item.nums }}</el-button>
                    </el-descriptions-item>
                </el-descriptions>
            </el-card>

            <!-- 手机卡卡片 -->
            <el-card class="stat-card">
                <div slot="header" class="card-title">
                    <span class="title-text">手机卡</span>
                </div>
                <el-descriptions :column="5" border direction="vertical" :labelStyle="{
                    color: '#409EFF',
                    textAlign: 'center',
                    fontSize: '12px'
                }" :contentStyle="{ textAlign: 'center', fontSize: '12px' }">
                    <el-descriptions-item v-for=" (item, index) in assertsData.mobileCardStatuses"
                        :label="item.amcStatus == 1 ? '闲置' :
                            item.amcStatus == 2 ? '报废' : item.amcStatus == 3 ? '维修' : item.amcStatus == 4 ? '领用' : item.amcStatus == 5 ? '借用' : '总数'" :key="index">
                        <el-button type="text" style="color:black" @click="toPath(3)"> {{ item.nums }}</el-button>
                    </el-descriptions-item>
                </el-descriptions>
            </el-card>

            <!-- 易耗品卡片 -->
            <el-card class="stat-card stat-card--small">
                <div slot="header" class="card-title">
                    <span class="title-text">易耗品</span>
                </div>
                <el-descriptions :column="5" border direction="vertical" :labelStyle="{
                    color: '#409EFF',
                    textAlign: 'center',
                    fontSize: '12px'
                }" :contentStyle="{ textAlign: 'center', fontSize: '12px' }">
                    <el-descriptions-item label="库存">
                        <el-button type="text" style="color:black" @click="toPath(4)"> {{
                            assertsData.consumablesStocks.acStock }}</el-button>
                    </el-descriptions-item>
                    <el-descriptions-item label="借出">
                        <el-button type="text" style="color:black" @click="toPath(4)"> {{
                            assertsData.consumablesStocks.acStockLend }}</el-button>
                    </el-descriptions-item>
                </el-descriptions>
            </el-card>
        </div>

        <!-- 底部内容区域 -->
        <div class="content-area">
            <!-- 左侧面板：图表 + 价值/质保/维修 -->
            <div class="content-left">
                <!-- 资产租用图表 -->
                <el-card class="chart-card">
                    <div slot="header" class="card-title">
                        <span class="title-text">资产租用</span>
                    </div>
                    <div class="chart-controls">
                        <el-select size="mini" v-model="formDatas.hire" clearable @change="partserch" placeholder="请选择"
                            style="width: 33%;">
                            <el-option label="全部" :value="1" key="1"></el-option>
                            <el-option label="资产" :value="2" key="2"></el-option>
                            <el-option label="配件" :value="3" key="3"></el-option>
                        </el-select>
                        <el-date-picker size="mini" @change="partserch" style="width: 33%;" v-model="formDatas.hireYear"
                            type="year" value-format="yyyy" placeholder="选择日期">
                        </el-date-picker>
                    </div>
                    <div class="chart-wrapper">
                        <div ref="eCharts" style="width: 100%;height: 100%;"></div>
                    </div>
                </el-card>

                <!-- 价值/质保/维修信息 -->
                <el-card class="info-card">
                    <div slot="header" class="card-tabs">
                        <el-button type="text" :style="{ color: OtherTypeid == 1 ? '#409EFF' : '#606266' }"
                            @click="OtherTypeid = 1">价值</el-button>
                        <el-button type="text" :style="{ color: OtherTypeid == 2 ? '#409EFF' : '#606266' }"
                            @click="OtherTypeid = 2">质保</el-button>
                        <el-button type="text" :style="{ color: OtherTypeid == 3 ? '#409EFF' : '#606266' }"
                            @click="OtherTypeid = 3">维修</el-button>
                    </div>
                    <div v-if="OtherTypeid == 1">
                        <el-descriptions :column="5" border direction="vertical" :labelStyle="{
                            color: '#409EFF',
                            textAlign: 'center',
                            fontSize: '12px'
                        }"
                            :contentStyle="{ textAlign: 'center', fontSize: '12px', color: 'black', fontWeight: 'bold' }">
                            <el-descriptions-item label="资产价值">
                                {{ assertsData.assetsMoneyValue }}
                            </el-descriptions-item>
                            <el-descriptions-item label="配件价值">
                                {{ assertsData.fittingMoneyValue }}
                            </el-descriptions-item>
                            <el-descriptions-item label="总价值">
                                {{ assertsData.fittingMoneyValue + assertsData.assetsMoneyValue }}
                            </el-descriptions-item>
                        </el-descriptions>
                    </div>
                    <div v-if="OtherTypeid == 2">
                        <el-descriptions :column="5" border direction="vertical" :labelStyle="{
                            color: '#409EFF',
                            textAlign: 'center',
                            fontSize: '12px'
                        }"
                            :contentStyle="{ textAlign: 'center', fontSize: '12px', color: 'black', fontWeight: 'bold' }">
                            <el-descriptions-item v-for=" (item, index) in repairData.hitchTypes"
                                :label="item.aahRepairType" :key="index">
                                {{ item.aahRepairMoney }}
                            </el-descriptions-item>
                        </el-descriptions>
                    </div>
                    <div v-if="OtherTypeid == 3">
                        <el-descriptions :column="5" border direction="vertical" :labelStyle="{
                            color: '#409EFF',
                            textAlign: 'center',
                            fontSize: '12px'
                        }" :contentStyle="{ textAlign: 'center', fontSize: '12px' }">
                            <el-descriptions-item label="资产过保">
                                <el-button type="text" style="color:black" @click="toPath(1)"> {{
                                    warrantyData.assetsOutNum }}</el-button>
                            </el-descriptions-item>
                            <el-descriptions-item label="即将过保">
                                <el-button type="text" style="color:black" @click="toPath(1)"> {{
                                    warrantyData.assetsInNum }}</el-button>
                            </el-descriptions-item>
                            <el-descriptions-item label="配件过保">
                                <el-button type="text" style="color:black" @click="toPath(2)"> {{
                                    warrantyData.fittingsOutNum }}</el-button>
                            </el-descriptions-item>
                            <el-descriptions-item label="即将过保">
                                <el-button type="text" style="color:black" @click="toPath(2)"> {{
                                    warrantyData.fittingsInNum }}</el-button>
                            </el-descriptions-item>
                        </el-descriptions>
                    </div>
                </el-card>
            </div>

            <!-- 右侧表格区域：入职人员/维修记录/资产过保 -->
            <div class="content-right">
                <el-card class="table-card">
                    <!-- 标签栏 + 刷新按钮 -->
                    <div slot="header" class="table-header">
                        <div class="table-tabs">
                            <el-button type="text" :style="{ color: Typeid == 6 ? '#409EFF' : '#606266' }"
                                @click="Typeid = 6">本周入职({{ entryWeekData.length }})</el-button>
                            <el-button type="text" :style="{ color: Typeid == 7 ? '#409EFF' : '#606266' }"
                                @click="Typeid = 7">下周入职({{ entrySoonData.length }})</el-button>
                            <el-button type="text" :style="{ color: Typeid == 8 ? '#409EFF' : '#606266' }"
                                @click="Typeid = 8">待入职员工({{ entryPendingData.length }})</el-button>
                            <el-button type="text" :style="{ color: Typeid == 1 ? '#409EFF' : '#606266' }"
                                @click="Typeid = 1">维修记录</el-button>
                            <el-button type="text" :style="{ color: Typeid == 2 ? '#409EFF' : '#606266' }"
                                @click="Typeid = 2">资产过保</el-button>
                        </div>
                        <el-button size="mini" icon="el-icon-refresh" circle @click="refreshEntryData"></el-button>
                    </div>
                    <!-- 表格内容 -->
                    <div class="table-body">
                        <div class="table-more" v-if="Typeid != 6 && Typeid != 7 && Typeid != 8">
                            <el-button type="text" @click="gtoPath()">更多</el-button>
                        </div>
                        <div v-if="Typeid == 1">
                            <ve-table ref="wxtable" v-if="wxdata" :columns="columnsWx" :table-data="wxdata"
                                :max-height="600" :border-x="true" :border-y="true" :scrollWidth="10"
                                :cell-style-option="cellStyleOption" style="width: 100%" />
                            <div v-show="wxdata.length == 0" class="empty-data">暂无数据</div>
                        </div>
                        <div v-if="Typeid == 2">
                            <ve-table ref="gbtable" :columns="columnsGb" :table-data="gbdata" :max-height="600"
                                :border-x="true" :border-y="true" :scrollWidth="10" :cell-style-option="cellStyleOption"
                                style="width: 100%" />
                            <div v-show="gbdata.length == 0" class="empty-data">暂无数据</div>
                        </div>
                        <div v-if="Typeid == 6">
                            <ve-table ref="zbtableWeek" v-if="entryWeekData" :columns="columnsZb" :table-data="entryWeekData"
                                :max-height="600" :border-x="true" :border-y="true" :scrollWidth="10"
                                :cell-style-option="cellStyleOption" style="width: 100%" />
                            <div v-show="entryWeekData.length == 0" class="empty-data">暂无数据</div>
                        </div>
                        <div v-if="Typeid == 7">
                            <ve-table ref="zbtableSoon" v-if="entrySoonData" :columns="columnsZb" :table-data="entrySoonData"
                                :max-height="600" :border-x="true" :border-y="true" :scrollWidth="10"
                                :cell-style-option="cellStyleOption" style="width: 100%" />
                            <div v-show="entrySoonData.length == 0" class="empty-data">暂无数据</div>
                        </div>
                        <div v-if="Typeid == 8">
                            <ve-table ref="zbtablePending" v-if="entryPendingData" :columns="columnsZb" :table-data="entryPendingData"
                                :max-height="600" :border-x="true" :border-y="true" :scrollWidth="10"
                                :cell-style-option="cellStyleOption" style="width: 100%" />
                            <div v-show="entryPendingData.length == 0" class="empty-data">暂无数据</div>
                        </div>
                        <div v-if="Typeid == 4">
                            <ve-table ref="pgbdata" v-if="pgbdata" :columns="columnsPgb" :table-data="pgbdata"
                                :max-height="450" :border-x="true" :border-y="true" :scrollWidth="10"
                                :cell-style-option="cellStyleOption" style="width: 100%" />
                            <div v-show="pgbdata.length == 0" class="empty-data">暂无数据</div>
                        </div>
                        <div v-if="Typeid == 5">
                            <ve-table ref="pzbdata" v-if="pzbdata" :columns="columnsPzb" :table-data="pzbdata"
                                :max-height="450" :border-x="true" :border-y="true" :scrollWidth="10"
                                :cell-style-option="cellStyleOption" style="width: 100%" />
                            <div v-show="pzbdata.length == 0" class="empty-data">暂无数据</div>
                        </div>
                    </div>
                </el-card>
            </div>
        </div>
    </div>
</template>

<script>
import echarts from 'echarts'
import {
    getStatisticsNums, getStatisticsRepair, getStatisticsWarranty, getStatisticsHire,getStatisticsEntrySoon
} from "../api/api";
export default {

    name: '',
    components: {

    },
    data() {
        return {
            aacType: 0,
            formDatas: {
                hire: '',
                hireType: '',
                hireYear: '',
            },
            echartsStr: '',
            hireList: {
                datax: [],
                datay: [],
            },
            OtherTypeid: 1,
            Typeid: 6,
            columnsWx: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "aahType",
                    key: "aahType",
                    title: "类型",
                    align: "center",
                    fixed: 'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return <span>{row.aahType == 1 ? '设备' : '配件'}</span>;
                    },
                },
                {
                    field: "aahThisName",
                    key: "aahThisName",
                    title: "故障资产",
                    align: "center",
                },
                {
                    field: "aahRepairMoney",
                    key: "aahRepairMoney",
                    title: "维修价格",
                    align: "center",
                },
                {
                    field: "aahRepairType",
                    key: "aahRepairType",
                    title: "维修方式",
                    align: "center",
                },
                {
                    field: "aahStatus",
                    key: "aahStatus",
                    title: "状态",
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.aahStatus == 1 ? <el-tag size="mini" type="danger" > 待处理 </el-tag> : row.aahStatus == 2
                                        ? <el-tag size="mini" type="success" > 已处理 </el-tag> : <el-tag size="mini" type="info" > 已删除 </el-tag>
                                }
                            </span>
                        );
                    },
                },
                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },

            ],
            columnsGb: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    fixed: 'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "aaName",
                    key: "b",
                    title: "型号",
                    align: "center",
                    width: 100,
                    fixed: 'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return <span>{row.aaName}</span>;
                    },
                },
                {
                    field: "aaNumber",
                    key: "aaNumber",
                    title: "资产编号",
                    width: 150,
                    align: "center",
                },
                {
                    field: "aacName",
                    key: "aacName",
                    title: "资产分类",
                    width: 100,
                    align: "center",
                },
                {
                    field: "amName",
                    key: "amName",
                    title: "资产厂商",
                    align: "center",
                    width: 100,
                },
                {
                    field: "aaDateBuy",
                    key: "aaDateBuy",
                    title: "购入日期",
                    align: "center",
                    edit: false,
                    width: 200,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return <span>{row.aaDateBuy}</span>;
                    },
                },
                {
                    field: "aaDateWarranty",
                    key: "aaDateWarranty",
                    title: "过保日期",
                    align: "center",
                    width: 150,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return <span>{row.aaDateWarranty}</span>;
                    },
                },
                {
                    field: "aaOwnerType",
                    key: "aaOwnerType",
                    title: "拥有方式",
                    align: "center",
                    width: 100,
                },
                {
                    field: "aaPurchaseChannels",
                    key: "aaPurchaseChannels",
                    title: "购买渠道",
                    align: "center",
                    width: 120,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                {
                    field: "aaConfiguration",
                    key: "aaConfiguration",
                    title: "配置",
                    align: "center",
                    width: 150,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                {
                    field: "aaCodeSn",
                    key: "aaCodeSn",
                    title: "SN码",
                    align: "center",
                    width: 100,
                },
                {
                    field: "aaBindAccount",
                    key: "aaBindAccount",
                    title: "绑定账号",
                    align: "center",
                    width: 100,
                },
                {
                    field: "aaDes",
                    key: "aaDes",
                    title: "备注",
                    align: "center",
                    width: 150,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                {
                    field: "ardName",
                    key: "ardName",
                    title: "折旧规则",
                    align: "center",
                    width: 150,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },

            ],
            columnsZb: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "iuName",
                    key: "b",
                    title: "招聘",
                    align: "center",
                    width: 100,
                    fixed: 'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return <span>{row.iuName}</span>;
                    },
                },
                {
                    field: "ijaName",
                    key: "ijaName",
                    title: "应聘者",
                    width: 100,
                    align: "center",
                },
                {
                    field: "ijaPost",
                    key: "ijaPost",
                    title: "岗位",
                    width: 150,
                    align: "center",
                },
                {
                    field: "ijaPhone",
                    key: "ijaPhone",
                    title: "手机号",
                    align: "center",
                    width: 200,
                },
                {
                    field: "ijaSex",
                    key: "ijaSex",
                    title: "性别",
                    align: "center",
                    edit: false,
                    width: 50,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return <span>{row.ijaSex}</span>;
                    },
                },
                {
                    field: "ijaBaseCity",
                    key: "ijaBaseCity",
                    title: "base城市",
                    align: "center",
                    width: 100,
                },
                {
                    field: "ijaEntryDateAgree",
                    key: "ijaEntryDateAgree",
                    title: "待入职时间",
                    align: "center",
                    width: 150,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return <span>{row.ijaEntryDateAgree}</span>;
                    },
                },

            ],
            columnsPgb: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "afName",
                    key: "b",
                    title: "配件名称",
                    align: "center",
                    width: 100,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return <span>{row.afName}</span>;
                    },
                },
                {
                    field: "afNumber",
                    key: "afNumber",
                    title: "配件编号",
                    fixed: 'left',
                    width: 150,
                    align: "center",
                },
                {
                    field: "afcName",
                    key: "afcName",
                    title: "配件分类",
                    width: 100,
                    align: "center",
                },
                {
                    field: "amName",
                    key: "amName",
                    title: "资产厂商",
                    align: "center",
                    width: 100,
                },
                {
                    field: "afDateBuy",
                    key: "afDateBuy",
                    title: "购入日期",
                    align: "center",
                    edit: false,
                    width: 200,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return <span>{row.afDateBuy}</span>;
                    },
                },
                {
                    field: "afDateWarranty",
                    key: "afDateWarranty",
                    title: "过保日期",
                    align: "center",
                    edit: false,
                    width: 200,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return <span>{row.afDateWarranty}</span>;
                    },
                },
                {
                    field: "afOwnerType",
                    key: "afOwnerType",
                    title: "拥有方式",
                    align: "center",
                    width: 100,
                },
                {
                    field: "afDes",
                    key: "afDes",
                    title: "备注",
                    align: "center",
                    width: 150,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                {
                    field: "afFiles",
                    key: "afFiles",
                    title: "图片",
                    width: 150,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.afFiles ? <el-image ref="scrImg" id="scrimg" src={row.afFiles.split(',')[0]} alt="" fit="fill" style="width: 100%;height: 50px;"
                                        previewSrcList={row.afFiles.split(',')}></el-image> : <span></span>
                                }
                            </span>
                        );
                    },
                },
                {
                    field: "ardName",
                    key: "ardName",
                    title: "折旧规则",
                    align: "center",
                    width: 150,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },

            ],
            columnsPzb: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "afName",
                    key: "b",
                    title: "配件名称",
                    align: "center",
                    width: 100,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return <span><el-button size="mini" type="text">{row.afName}</el-button></span>;
                    },
                },
                {
                    field: "afNumber",
                    key: "afNumber",
                    title: "配件编号",
                    fixed: 'left',
                    width: 150,
                    align: "center",
                },
                {
                    field: "afcName",
                    key: "afcName",
                    title: "配件分类",
                    width: 100,
                    align: "center",
                },
                {
                    field: "amName",
                    key: "amName",
                    title: "资产厂商",
                    align: "center",
                    width: 100,
                },
                {
                    field: "afDateBuy",
                    key: "afDateBuy",
                    title: "购入日期",
                    align: "center",
                    edit: false,
                    width: 200,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return <span>{row.afDateBuy}</span>;
                    },
                },
                {
                    field: "afDateWarranty",
                    key: "afDateWarranty",
                    title: "过保日期",
                    align: "center",
                    edit: false,
                    width: 200,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return <span>{row.afDateWarranty}</span>;
                    },
                },
                {
                    field: "afOwnerType",
                    key: "afOwnerType",
                    title: "拥有方式",
                    align: "center",
                    width: 100,
                },
                {
                    field: "afDes",
                    key: "afDes",
                    title: "备注",
                    align: "center",
                    width: 150,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                {
                    field: "afFiles",
                    key: "afFiles",
                    title: "图片",
                    width: 150,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.afFiles ? <el-image ref="scrImg" id="scrimg" src={row.afFiles.split(',')[0]} alt="" fit="fill" style="width: 100%;height: 50px;"
                                        previewSrcList={row.afFiles.split(',')}></el-image> : <span></span>
                                }
                            </span>
                        );
                    },
                },
                {
                    field: "ardName",
                    key: "ardName",
                    title: "折旧规则",
                    align: "center",
                    width: 150,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },

            ],

            // 表头样式配置
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            assertsData: {
                consumablesStocks: {
                    acStock: 0
                }
            },
            repairData: '',
            warrantyData: '',
            wxdata: [],
            gbdata: [],
            zbdata: [],
            // 本周入职 / 下周入职 / 待入职员工
            entryWeekData: [],
            entrySoonData: [],
            entryPendingData: [],
            pzbdata: [],
            pgbdata: [],

        }
    },
    watch: {},
    created() { },
    mounted() {
        const _this = this
        window.addEventListener('resize', function () {
            _this.echartsStr.resize()
        });
    },
    activated() {
        this.hireList = {
            datax: [],
            datay: [],
        },
            getStatisticsNums().then(res => {
                this.assertsData = res.data;
            })
        getStatisticsRepair().then(res => {
            this.repairData = res.data;
            this.wxdata = res.data.ajAssetsHitchList
        })
        getStatisticsEntrySoon().then(res => {
            this.entryWeekData = res.data.entryWeek || []
            this.entrySoonData = res.data.entryNextWeek || []
            this.entryPendingData = res.data.entrySoon || []
        })
        getStatisticsWarranty().then(res => {
            this.warrantyData = res.data;
            this.gbdata = res.data.ajAssetsListOut
            this.zbdata = res.data.ajAssetsListIn
            this.pzbdata = res.data.ajFittingsListIn
            this.pgbdata = res.data.ajFittingsListOut
        })
        getStatisticsHire().then(res => {
            const data = res.data;
            data.forEach((item, index) => {
                if (item.month) {
                    this.hireList.datax.push(item.month)
                    this.hireList.datay.push(item.value)
                } else {
                    this.hireList.datax.push(item.year)
                    this.hireList.datay.push(item.value)
                }
                this.DrawEcharts()
            })
        })
    },
    methods: {
        partserch() {
            this.hireList = {
                datax: [],
                datay: [],
            },
                getStatisticsHire(this.formDatas).then(res => {
                    const data = res.data;
                    if (data.length > 0) {
                        data.forEach((item, index) => {
                            if (item.month) {
                                this.hireList.datax.push(item.month)
                                this.hireList.datay.push(item.value)
                            } else {
                                this.hireList.datax.push(item.year)
                                this.hireList.datay.push(item.value)
                            }
                            this.DrawEcharts()
                        })
                    } else {
                        this.DrawEcharts()
                    }

                })
        },

        DrawEcharts() {
            this.echartsStr = this.$echarts.init(this.$refs.eCharts)
            this.echartsStr.setOption({
                grid: {
                    top: "15%",
                    left: "2%",
                    right: "2%",
                    bottom: "2%",
                    containLabel: true
                },

                xAxis: {
                    type: 'category',
                    data: this.hireList.datax
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        data: this.hireList.datay,
                        type: 'line',
                        radius: '0%',
                    }
                ]
            })
        },

        gtoPath() {
            if (this.Typeid == 1) {
                this.$router.push({
                    path: '/Home/breakdown'
                })
            } else if (this.Typeid == 2 ) {
                this.$router.push({
                    path: '/Home/corporateAssets'
                })
            } else if (this.Typeid == 4 || this.Typeid == 5) {
                this.$router.push({
                    path: '/Home/AccessoryPartAll'
                })
            }

        },
        // 刷新入职人员数据
        refreshEntryData() {
            getStatisticsEntrySoon().then(res => {
                this.entryWeekData = res.data.entryWeek || []
                this.entrySoonData = res.data.entryNextWeek || []
                this.entryPendingData = res.data.entrySoon || []
            })
        },
        toPath(val, status, aacId,aaOwnerType) {
            if (status == 0) {
                status = null;
            }
            switch (val) {
                case 1:
                    this.$router.push({ path: '/Home/corporateAssets', query: { 'id': status, aacId: aacId } })
                    break;
                case 2:
                    this.$router.push({ path: '/Home/AccessoryPartAll' })
                    break;
                case 3:
                    this.$router.push({ path: '/Home/phoneCard' })
                    break;
                case 4:
                    this.$router.push({ path: '/Home/Consumebs' })
                    break;
                case 5:
                    this.$router.push({ path: '/Home/corporateAssets', query: { 'aaOwnerType': aaOwnerType, aacId: aacId } })
            }

        },
    }
}
</script>

<style scoped>
/* ===== 页面容器 ===== */
.home-page {
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 10px 12px;
    box-sizing: border-box;
    background: #f0f2f5;
}

/* ===== 顶部统计卡片区域 ===== */
.stats-area {
    height: 20%;
    min-height: 110px;
    display: flex;
    gap: 10px;
}

.stat-card {
    height: 100%;
    overflow: hidden;
}

.stat-card--main {
    flex: 4;
}

.stat-card:not(.stat-card--main):not(.stat-card--small) {
    flex: 2;
}

.stat-card--small {
    flex: 1;
}

/* 卡片头部 - 标签切换 */
.card-tabs {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 2px;
}

.card-title {
    display: flex;
    align-items: center;
}

.title-text {
    font-size: 15px;
    font-weight: 600;
    color: #409EFF;
}

/* ===== 底部内容区域 ===== */
.content-area {
    flex: 1;
    display: flex;
    gap: 10px;
    margin-top: 10px;
    min-height: 0;
}

.content-left {
    width: 30%;
    display: flex;
    flex-direction: column;
    gap: 10px;
    min-height: 0;
}

/* 资产租用图表卡片 */
.chart-card {
    height: 60%;
    display: flex;
    flex-direction: column;
}

.chart-card /deep/ .el-card__body {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
}

.chart-controls {
    display: flex;
    gap: 8px;
    margin-bottom: 8px;
}

.chart-wrapper {
    flex: 1;
    min-height: 0;
}

/* 价值/质保/维修信息卡片 */
.info-card {
    flex: 1;
    min-height: 0;
    overflow: auto;
}

/* 右侧表格区域 */
.content-right {
    flex: 1;
    min-width: 0;
    min-height: 0;
}

.table-card {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.table-card /deep/ .el-card__body {
    flex: 1;
    overflow: auto;
    min-height: 0;
}

/* 表格头部 */
.table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.table-tabs {
    display: flex;
    align-items: center;
    gap: 2px;
}

.table-body {
    width: 100%;
    height: 100%;
}

.table-more {
    text-align: right;
    color: #409EFF;
    padding: 0 8px 4px;
}

/* ===== 卡片统一样式覆盖 ===== */
.home-page /deep/ .el-card__header {
    padding: 8px 14px;
    border-bottom: 1px solid #e8e8e8;
}

.home-page /deep/ .el-card__body {
    width: 100%;
    padding: 10px 14px;
}

/* 表头高亮（橙色主题） */
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

/* ===== ve-table 表格行高压缩 ===== */
.home-page /deep/ .ve-table .ve-table-header-tr {
    height: 26px !important;
}

.home-page /deep/ .ve-table .ve-table-header-th {
    padding: 0 4px !important;
    font-size: 13px !important;
    line-height: 26px !important;
    background-color: #f5f7fa !important;
}

.home-page /deep/ .ve-table .ve-table-body-tr {
    height: 24px !important;
}

.home-page /deep/ .ve-table .ve-table-body-td {
    padding: 0 4px !important;
    font-size: 13px !important;
    line-height: 24px !important;
}

.home-page /deep/ .ve-table {
    width: 100% !important;
}

.home-page /deep/ .ve-table .ve-table-container {
    width: 100% !important;
}
</style>
